import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { theme } from '../utils/theme';

const CTA = () => {
  const { t } = useTranslation('cta');

  return (
    <div className="relative z-20 flex items-center overflow-hidden bg-background-primary">
      <div className={theme.container + ' relative flex flex-col sm:flex-row px-6 py-16'}>
        <div className="relative z-20 flex flex-col sm:w-2/3 lg:w-2/5">
          <span className="w-20 h-2 mb-12 bg-primary"></span>
          <h1 className={theme.text.display + ' text-text-primary uppercase leading-none'}>
            {t('title')}
          </h1>
          <h2 className={theme.text.h3 + ' mt-2 text-text-secondary'}>
            {t('subtitle')}
          </h2>
          <p className={theme.text.body + ' mt-4'}>
            {t('description')}
          </p>
          <div className="flex mt-8">
            <Link
              to="/register"
              className={theme.button.base + ' ' + theme.button.cta + ' ' + theme.button.sizes.lg + ' uppercase'}
            >
              {t('button')}
            </Link>
          </div>
        </div>
        <div className="relative hidden sm:block sm:w-1/3 lg:w-3/5">
          <video
            src="/cta/cta.mp4"
            autoPlay
            loop
            muted
            playsInline
            className="max-w-xs m-auto md:max-w-sm rounded-2xl"
            alt="CTA video"
          />
        </div>
      </div>
    </div>
  );
};

export default CTA;